module.exports = __webpack_public_path__ + "media/images/sites/health/f-ferramentas-77eb8d453131c029afcd26d0d9d7efd7.jpg";